<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1042.46 266.83"
    width="73"
    height="21"
  >
    <path
      class="cls-1 fill-[#0b2948]"
      d="M386.83,129.62H368.91v81H335.6v-81H323.53V102H335.6V98.84q0-20.06,11.49-30.48t33.7-10.42c2.47,0,4.29.06,5.45.19V86.38q-9.54-.59-13.43,2.72T368.91,101v1h17.92Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M402.9,85.5a16.71,16.71,0,0,1-5.56-12.76,16.92,16.92,0,0,1,5.56-12.95q5.55-5.16,14.31-5.16,8.57,0,14.12,5.16a16.94,16.94,0,0,1,5.55,12.95,16.74,16.74,0,0,1-5.55,12.76q-5.55,5.16-14.12,5.16Q408.45,90.66,402.9,85.5ZM433.77,102V210.64H400.46V102Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M520.25,210.64l-20.84-30.19-17.53,30.19h-36l35.84-55.51L444.87,102h37.4l20.84,30,17.53-30h36l-36.42,54.73,37.4,53.95Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M630.72,129.62H612.8v81H579.49v-81H567.42V102h12.07V98.84q0-20.06,11.49-30.48t33.7-10.42c2.47,0,4.29.06,5.45.19V86.38q-9.54-.59-13.43,2.72T612.8,101v1h17.92Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M663.85,205.38a49.9,49.9,0,0,1-20.06-19.47q-7.31-12.66-7.3-29.61,0-16.76,7.4-29.51a50.23,50.23,0,0,1,20.25-19.57,64.35,64.35,0,0,1,57.66,0,50.26,50.26,0,0,1,20.26,19.57q7.4,12.77,7.4,29.51T742,185.81a50.67,50.67,0,0,1-20.45,19.57,61.11,61.11,0,0,1-28.93,6.82A59.94,59.94,0,0,1,663.85,205.38Zm45-29q6.72-7,6.72-20.06T709,136.24a22.14,22.14,0,0,0-32.23-.1q-6.43,6.92-6.43,20.16,0,13,6.33,20.06a20.47,20.47,0,0,0,15.87,7A21.7,21.7,0,0,0,708.85,176.36Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M806.82,106a37.66,37.66,0,0,1,19.48-5.16V136h-9.16q-12.46,0-18.7,5.36t-6.23,18.8v50.44H758.9V102h33.31v18.11A44,44,0,0,1,806.82,106Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M1011.24,113.06q12,12.27,12,34.09v63.49H990.11v-59q0-10.53-5.56-16.27t-15.29-5.74q-9.74,0-15.29,5.74t-5.55,16.27v59H915.31v-59q0-10.53-5.55-16.27t-15.29-5.74q-9.75,0-15.29,5.74t-5.55,16.27v59H840.32V102h33.31v13.63a35.64,35.64,0,0,1,13.24-10.81,41.69,41.69,0,0,1,18.51-4,45,45,0,0,1,21.91,5.26,37.56,37.56,0,0,1,15.09,15,43.74,43.74,0,0,1,15.39-14.61A41.53,41.53,0,0,1,979,100.79Q999.27,100.79,1011.24,113.06Z"
    />
    <path
      class="cls-2 fill-[#fff]"
      d="M196,95.32c-3,4.4-7.33,7.18-11.87,9.73-9.41,5.3-19.84,7.6-30.17,10.11q-7.54,1.82-15.14,3.27c-1.52.3-1.87.83-1.85,2.31.06,9.38.27,18.76-.11,28.12-.44,10.48-1.54,21-5.7,30.76a24.69,24.69,0,0,1-4.32,6.77c-3.6,4-8.93,4-12.64.07-5.37-5.58-8.28-12.54-10.57-19.79A131.1,131.1,0,0,1,98,116.9c.17-1.91.37-3.81.53-5.71a.75.75,0,0,1,0-.11v0c.17-1.09.39-2.21.64-3.29,2.58-11,9.71-18.52,19.9-23.22,11.19-5.16,23.1-6.81,35.28-7.06a180.42,180.42,0,0,1,35.33,2.94C197.12,81.73,200.18,89.08,196,95.32Z"
    />
    <path
      class="cls-2 fill-[#fff]"
      d="M164.35,127a17.5,17.5,0,1,0,17.47,17.35A17.39,17.39,0,0,0,164.35,127Z"
    />
    <path
      class="cls-1 fill-[#0b2948]"
      d="M210.42,4.92H85c-1.42,0-2.82.06-4.21.15A65.8,65.8,0,0,0,19.24,70.72V196.1a65.8,65.8,0,0,0,61.59,65.65c1.39.09,2.79.15,4.21.15H210.42a65.8,65.8,0,0,0,65.8-65.8V70.72A65.8,65.8,0,0,0,210.42,4.92Zm-46,157a17.51,17.51,0,1,1,17.41-17.65A17.42,17.42,0,0,1,164.41,162ZM196,95.32c-3,4.4-7.33,7.18-11.87,9.73-9.41,5.3-19.84,7.6-30.17,10.11q-7.54,1.82-15.14,3.27c-1.52.3-1.87.83-1.85,2.31.06,9.38.27,18.76-.11,28.12-.44,10.48-1.54,21-5.7,30.76a24.69,24.69,0,0,1-4.32,6.77c-3.6,4-8.93,4-12.64.07-5.37-5.58-8.28-12.54-10.57-19.79A131.1,131.1,0,0,1,98,116.9c.17-1.91.37-3.81.53-5.71a.75.75,0,0,1,0-.11v0c.17-1.09.39-2.21.64-3.29,2.58-11,9.71-18.52,19.9-23.22,11.19-5.16,23.1-6.81,35.28-7.06a180.42,180.42,0,0,1,35.33,2.94C197.12,81.73,200.18,89.08,196,95.32Z"
    />
  </svg>
</template>
